import { MagnifierState } from './magnifier.types';

export const MAGNIFIER_INITIAL_STATE: MagnifierState = {
  isActive: false,
};
